const initialState = {
  loaded: false,
  data: null,
}

export default initialState
